/**
 * Page chrome: navbar + page content + footer, plus the global animation
 * runtime. Every page renders its content inside <SiteLayout> and passes the
 * `categories` it loaded in getStaticProps. Home passes `isHome` so the hero
 * load sequence (not the generic one) runs.
 */
import type { FC, ReactNode } from 'react'
import type { Category } from '@/types'

import { useRouter } from 'next/router'

import { Navbar } from '@/components/layout/navbar'
import { Footer } from '@/components/layout/footer'
import { CartDrawer } from '@/components/cart/cart-drawer'
import { SiteAnimations } from '@/components/animations/site-animations'

interface SiteLayoutProps {
    children: ReactNode
    categories: Category[]
    isHome?: boolean
}

export const SiteLayout: FC<SiteLayoutProps> = ({ children, categories, isHome = false }) => {
    const router = useRouter()

    return (
        <>
            <Navbar categories={categories} />

            <main>{children}</main>

            <Footer categories={categories} />

            <CartDrawer />

            <SiteAnimations key={router.asPath} isHome={isHome} />
        </>
    )
}
